import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import MaterialInput from "@Shared/components/inputs/material-input.vue";
import { validationMixin } from "vuelidate";
import { required, maxLength, minLength } from "vuelidate/lib/validators";
import { defineComponent, ref } from "@vue/composition-api";
export default defineComponent({
  name: "LenderCodeVerificationPage",
  components: {
    SimpleButton,
    MaterialInput
  },
  mixins: [validationMixin],
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    codeVerified: {
      type: Boolean,
      default: true
    }
  },
  validations: {
    lenderCode: {
      required,
      maxLenderCodeLength: maxLength(6),
      minLenderCodeLength: minLength(6)
    }
  },
  setup(props, {
    emit
  }) {
    const lenderCode = ref("");
    const verifyLenderCode = () => {
      emit("verify-lender-code", lenderCode.value);
    };
    return {
      lenderCode,
      verifyLenderCode
    };
  }
});